import { SectionContainer, Hero, Games, Platforms, Thumbnail, BlurBox, Shoppingcard, Bimageslider, Blogposts, HeroImage, Companies, Services, Features, Offerings, Pricing, Testimonial, Tools, Banner, FeatureSection, FeaturesGridSection } from "@/components";
import CTA from "../contents/cta";
import Reviews from "../contents/reviews";


const HomeSection = () => {
    return (
        <>
            <SectionContainer>

                <div className="relative flex flex-col items-start justify-center w-full mx-auto">

                    <div className="mx-auto relative flex flex-col items-cennter justify-center w-full">


                        <div className="mb-14">
                            <Games />
                        </div>

                        <div className="my-24">
                            <FeatureSection />
                        </div>


                        <div className="mb-24">
                            <Platforms />
                        </div>


                        <div className="mb-24">
                            <FeaturesGridSection />
                        </div>


                        <div className="mb-24">
                            <Shoppingcard />
                        </div>


                        <div className="mb-24">
                            <Blogposts />
                        </div>


                        <div className="mb-24">
                            <Bimageslider />
                        </div>


                        {/* <HeroImage /> */}

                        {/* <Companies />

                        <Services />

                        <Features />

                        <Offerings />

                        <Pricing />

                        <Testimonial /> */}

                        <Reviews />

                        <CTA />

                    </div>

                </div>

            </SectionContainer>
        </>
    )
};

export default HomeSection
